import { apiClient, ApiClientConfig, PaginatedRequestParams } from 'api';
import { axiosInstance } from 'api/axios-instance';
export type CreateLabelDTO = {
  title?: string;
  description?: string | null;
};
export type UpdateLabelDTO = {
  id?: string;
  title?: string;
  description?: string;
  title_arabic?: string;
  description_arabic?: string;
};
export const SponserApiService = () => {
  const baseURL = process.env.REACT_APP_BASE_V2_URL;

  const getSponserList = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/admin/Sponsor`,
      params,
    });

    return response.data;
  };

  const getSponserById = async (
    params: PaginatedRequestParams,
    callConfig?: Partial<ApiClientConfig>,
  ) => {
    const response = await apiClient<any>({
      ...callConfig,
      endpoint: `${baseURL}/admin/Sponsor`,
      params,
    });

    return response.data;
  };

  const createSponser = async (formData: FormData) => {
    const response = await axiosInstance.post(
      `${baseURL}/admin/Sponsor`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      },
    );

    return response.data;
  };

  return {
    getSponserList,
    createSponser,
    getSponserById,
  };
};
